export const isBot = () => {
  const result = /bot|crawler|spider|crawling|lighthouse/i.test(navigator.userAgent);
  return result;
};
